import { ConvexHttpClient } from "convex/browser"

let client: ConvexHttpClient | null = null

export function getConvexHttpClient() {
  const url = import.meta.env.VITE_CONVEX_URL
  if (!url) {
    throw new Error("VITE_CONVEX_URL is not set")
  }

  if (!client) {
    client = new ConvexHttpClient(url)
  }

  return client
}
